"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class MemberService {
    /**
     * @returns MemberType List of all member types for each team for the user
     * @throws ApiError
     */
    static getUserPersona() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/member/persona',
            errors: {
                403: `Unauthorized`,
            },
        });
    }
}
exports.MemberService = MemberService;
